module.exports = __webpack_public_path__ + "static/img/logo--gambling-commission.f567f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo--gambling-commission.png
// module id = 9e98
// module chunks = 5